import React, {memo} from "react";
import ModerationPage from "../../components/common/moderation/ModerationPage";
import {questionsRef} from "../../config/firebaseConfig";
import {FrontendRoutes} from "../../constants";

const QAModerationPage = ({users}) => (<ModerationPage label={'QA Moderation'}
                                                       tableRef={questionsRef}
                                                       users={users}
                                                       link={FrontendRoutes.SOCIAL_WALL_MODERATION}
                                                       linkLabel='Go to Social Wall Moderation'/>)

export default memo(QAModerationPage)